var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuriosity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ce3cd8zsaa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.834749 0 0 0 0 0.000080 0 0 0 0 0.698996 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ce3cd8zsaa)",
    transform: "translate(-421 -383)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M16.03 18.744c0-1.712 1.388-3.1 3.1-3.1 1.712 0 3.1 1.388 3.1 3.1 0 1.713-1.389 3.102-3.1 3.102-1.712 0-3.1-1.39-3.1-3.102zm20.26 0c0 1.713-1.389 3.102-3.101 3.102s-3.101-1.389-3.101-3.102c0-1.712 1.39-3.1 3.101-3.1 1.712-.001 3.1 1.388 3.1 3.1zM25.953 38.758c-4.54 2.433-9.677-2.886-11.532-7.352-.318-.764.044-1.642.81-1.96.188-.079.383-.116.575-.116.588.002 1.146.349 1.385.927 1.389 3.342 3.732 3.96 9.262 5.001 0 0 4.595.77-.5 3.5zm16.78 13.09H9.114C4.089 51.847 0 47.758 0 42.732V9.114C0 4.088 4.089 0 9.115 0h33.617c5.027 0 9.115 4.089 9.115 9.115v33.617c0 5.027-4.088 9.115-9.114 9.115zM9.114 4.287c-2.66 0-4.825 2.165-4.825 4.826v33.617c0 2.661 2.165 4.826 4.825 4.826h33.617c2.661 0 4.826-2.165 4.826-4.826V9.115c0-2.661-2.165-4.826-4.825-4.826H9.114z",
    transform: "translate(421 383)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuriosity);
export default __webpack_public_path__ + "static/media/curiosity.ded0433f1658f0c7a4433266ae85efae.svg";
export { ForwardRef as ReactComponent };